/*============================================================================
  Ajax the add to cart experience by revealing it in a side drawer
  Plugin Documentation - http://shopify.github.io/Timber/#ajax-cart
  (c) Copyright 2015 Shopify Inc. Author: Carson Shold (@cshold). All Rights Reserved.

  This file includes:
    - Basic Shopify Ajax API calls
    - Ajax cart plugin

  This requires:
    - jQuery 1.8+
    - handlebars.min.js (for cart template)
    - modernizr.min.js
    - snippet/ajax-cart-template.liquid

  Customized version of Shopify's jQuery API
  (c) Copyright 2009-2015 Shopify Inc. Author: Caroline Schnapp. All Rights Reserved.
==============================================================================*/
if ((typeof ShopifyAPI) === 'undefined') { ShopifyAPI = {}; }

/*============================================================================
  API Helper Functions
==============================================================================*/
function attributeToString(attribute) {
    if ((typeof attribute) !== 'string') {
        attribute += '';
        if (attribute === 'undefined') {
            attribute = '';
        }
    }
    return jQuery.trim(attribute);
};

/*============================================================================
  API Functions
==============================================================================*/
ShopifyAPI.onCartUpdate = function(cart) {
    //alert('There are now ' + cart.item_count + ' items in the cart.');
};

ShopifyAPI.updateCartNote = function(note, callback) {
    var $body = jQuery(document.body),
        params = {
            type: 'POST',
            url: '/cart/update.js',
            data: 'note=' + attributeToString(note),
            dataType: 'json',
            beforeSend: function() {
                $body.trigger('beforeUpdateCartNote.ajaxCart', note);
            },
            success: function(cart) {
                if ((typeof callback) === 'function') {
                    callback(cart);
                }
                else {
                    ShopifyAPI.onCartUpdate(cart);
                }
                $body.trigger('afterUpdateCartNote.ajaxCart', [note, cart]);
            },
            error: function(XMLHttpRequest, textStatus) {
                $body.trigger('errorUpdateCartNote.ajaxCart', [XMLHttpRequest, textStatus]);
                ShopifyAPI.onError(XMLHttpRequest, textStatus);
            },
            complete: function(jqxhr, text) {
                $body.trigger('completeUpdateCartNote.ajaxCart', [this, jqxhr, text]);
            }
        };
    jQuery.ajax(params);
};

ShopifyAPI.onError = function(XMLHttpRequest, textStatus) {
    var data = eval('(' + XMLHttpRequest.responseText + ')');
    if (!!data.message) {
        alert(data.message + '(' + data.status  + '): ' + data.description);
    }
};

/*============================================================================
  POST to cart/add.js returns the JSON of the cart
    - Allow use of form element instead of just id
    - Allow custom error callback
==============================================================================*/
ShopifyAPI.addItemFromForm = function(form, callback, errorCallback, directCheckout) {
    var $body = jQuery(document.body),
        params = {
            type: 'POST',
            url: '/cart/add.js',
            data: jQuery(form).serialize(),
            dataType: 'json',
            beforeSend: function(jqxhr, settings) {
                $body.trigger('beforeAddItem.ajaxCart', form);
            },
            success: function(line_item) {
                if ((typeof callback) === 'function') {
                    callback(line_item, form);
                }
                else {
                    ShopifyAPI.onItemAdded(line_item, form);
                }
                $body.trigger('afterAddItem.ajaxCart', [line_item, form]);
                if(directCheckout){
                    window.location.href ='/checkout';
                }
            },
            error: function(XMLHttpRequest, textStatus) {
                if ((typeof errorCallback) === 'function') {
                    errorCallback(XMLHttpRequest, textStatus);
                }
                else {
                    ShopifyAPI.onError(XMLHttpRequest, textStatus);
                }
                $body.trigger('errorAddItem.ajaxCart', [XMLHttpRequest, textStatus]);
            },
            complete: function(jqxhr, text) {
                $body.trigger('completeAddItem.ajaxCart', [this, jqxhr, text]);
            }
        };
    jQuery.ajax(params);
};

// Get from cart.js returns the cart in JSON
ShopifyAPI.getCart = function(callback) {
    jQuery(document.body).trigger('beforeGetCart.ajaxCart');
    jQuery.getJSON('/cart.js', function (cart, textStatus) {
        if ((typeof callback) === 'function') {
            callback(cart);
        }
        else {
            ShopifyAPI.onCartUpdate(cart);
        }
        jQuery(document.body).trigger('afterGetCart.ajaxCart', cart);
    });
};

// POST to cart/change.js returns the cart in JSON
ShopifyAPI.changeItem = function(line, quantity, callback) {
    var $body = jQuery(document.body),
        params = {
            type: 'POST',
            url: '/cart/change.js',
            data: 'quantity=' + quantity + '&line=' + line,
            dataType: 'json',
            beforeSend: function() {
                $body.trigger('beforeChangeItem.ajaxCart', [line, quantity]);
            },
            success: function(cart) {
                if ((typeof callback) === 'function') {
                    callback(cart);
                }
                else {
                    ShopifyAPI.onCartUpdate(cart);
                }
                $body.trigger('afterChangeItem.ajaxCart', [line, quantity, cart]);
            },
            error: function(XMLHttpRequest, textStatus) {
                $body.trigger('errorChangeItem.ajaxCart', [XMLHttpRequest, textStatus]);
                ShopifyAPI.onError(XMLHttpRequest, textStatus);
            },
            complete: function(jqxhr, text) {
                $body.trigger('completeChangeItem.ajaxCart', [this, jqxhr, text]);
            }
        };
    jQuery.ajax(params);
};

/*============================================================================
  Ajax Shopify Add To Cart
==============================================================================*/
var ajaxCart = (function(module, $) {

    'use strict';

    // Public functions
    var init, loadCart;

    // Private general variables
    var settings, isUpdating, $body;

    // Private plugin variables
    var $formContainer, $addToCart, $cartCountSelector, $cartCostSelector, $cartContainer, $drawerContainer;

    // Private functions
    var updateCountPrice, formOverride, itemAddedCallback, itemErrorCallback, cartUpdateCallback, buildCart, cartCallback, adjustCart, adjustCartCallback, createQtySelectors, qtySelectors, validateQty;

    /*============================================================================
      Initialise the plugin and define global options
    ==============================================================================*/
    init = function (options) {

        // Default settings
        settings = {
            formSelector       : 'form[action^="/cart/add"]',
            cartContainer      : '#cart-inner',
            addToCartSelector  : 'input[type="submit"]',
            cartCountSelector  : null,
            cartCostSelector   : null,
            moneyFormat        : $(document.documentElement).data("moneyformat"),
            disableAjaxCart    : false,
            enableQtySelectors : true,
            showVendor         : true
        };

        // Override defaults with arguments
        jQuery.extend(settings, options);

        // Select DOM elements
        $formContainer     = jQuery(settings.formSelector);
        $cartContainer     = jQuery(settings.cartContainer);
        $addToCart         = $formContainer.find(settings.addToCartSelector);
        $cartCountSelector = jQuery(settings.cartCountSelector);
        $cartCostSelector  = jQuery(settings.cartCostSelector);

        // General Selectors
        $body = jQuery(document.body);

        // Track cart activity status
        isUpdating = false;

        // Setup ajax quantity selectors on the any template if enableQtySelectors is true
        if (settings.enableQtySelectors) {
            qtySelectors();
        }

        // Take over the add to cart form submit action if ajax enabled
        if (!settings.disableAjaxCart && $addToCart.length) {
            formOverride();
        }

        // Run this function in case we're using the quantity selector outside of the cart
        adjustCart();
    };

    loadCart = function () {
        $body.addClass('drawer--is-loading');
        ShopifyAPI.getCart(cartUpdateCallback);
    };

    updateCountPrice = function (cart) {
      $('#side-cart-total').html("<span>Total</span>" + Shopify.formatMoney(cart.total_price, $(document.documentElement).data("moneyformat")));
      var free_shipping_amount = 50 * 1;
      var has_free_shipping_amount = false;
      if (free_shipping_amount > 0) {
        has_free_shipping_amount = true;
        free_shipping_amount = 50 * 1 * 100;
      };
      if (has_free_shipping_amount) {
        var amount_for_free_shipping = $('.amount-for-free-shipping');
        var free_shipping = $('.free-shipping');
        if (free_shipping_amount <= cart.total_price) {
          amount_for_free_shipping.hide();
          free_shipping.show();
        } else {
          var amount = free_shipping_amount - cart.total_price;
          amount_for_free_shipping.html("<span>Amount to free shipping</span>"+ Shopify.formatMoney(amount, $(document.documentElement).data("moneyformat")));
          amount_for_free_shipping.show();
          free_shipping.hide();
        }
      }
      var quantity = 0;
      $.each( cart.items, function( i, val ) {
        quantity = quantity + val.quantity;
      });
      $('#nav-sh .cart .no').first().html(quantity);
    };

    formOverride = function () {
        var directCheckout = '';
        $addToCart.click(function() {
            directCheckout = $(this).hasClass('direct-checkout')
            if (directCheckout) {
                $addToCart.closest($formContainer).trigger('submit');
            }
        });
        $formContainer.on('submit', function(evt) {
            evt.preventDefault();

            // Add class to be styled if desired
            $addToCart.removeClass('is-added').addClass('is-adding');

            // Remove any previous quantity errors
            jQuery('.qty-error').remove();

            // if(clicked.hasClass('direct-checkout')){
            //     window.location.href ='/checkout';
            // }
            ShopifyAPI.addItemFromForm(evt.target, itemAddedCallback, itemErrorCallback, directCheckout);
        });
    };

    itemAddedCallback = function (product) {
        $addToCart.removeClass('is-adding').addClass('is-added');

        ShopifyAPI.getCart(cartUpdateCallback);
    };

    itemErrorCallback = function (XMLHttpRequest, textStatus) {
        var data = eval('(' + XMLHttpRequest.responseText + ')');
        $addToCart.removeClass('is-adding is-added');

        if (!!data.message) {
            if (data.status == 422) {
                $formContainer.first().after('<div class="errors qty-error">'+ data.description +'</div>');
                if ($('.list-notifications').length == 0) {
                $body.find(".errors").insertAfter("#top-sh");
                $body.find(".errors").wrap( "<ul class='list-notifications'><li><p class='info'></p></li></ul>" ).contents().unwrap();
                var stickyHeaderHeight = 0;
                if (!$('#top-sh').hasClass('static') && !$('#nav-sh').hasClass('sticky') ) {
    							stickyHeaderHeight = stickyHeaderHeight + $('#top-sh').outerHeight();
    						}
    						if ($('#nav-sh').hasClass('sticky')) {
    							stickyHeaderHeight = stickyHeaderHeight + $('#nav-sh').outerHeight();
    						}
    						$('.list-notifications').scrollToFixed({
    							marginTop: stickyHeaderHeight
    						});
                $('.list-notifications').delay(6000).queue(function(){
    							$(this).slideUp().dequeue().delay(500).queue(function(){
    								$(this).remove().dequeue();
    							});
    						});
              }
            }
        }
    };

    cartUpdateCallback = function (cart) {
        // Update quantity and price
        updateCountPrice(cart);
        buildCart(cart);
    };

    buildCart = function (cart) {
        // Start with a fresh cart div
        $cartContainer.empty();
        // Show empty cart
        if (cart.item_count === 0) {
            $cartContainer
                .append('<p>' + "Cart is empty" + '</p>');
            cartCallback(cart);
            return;
        }

        // Handlebars.js cart layout
        var items = [],
            item = {},
            data = {},
            source = jQuery("#CartTemplate").html(),
            template = Handlebars.compile(source);
        // Add each item to our handlebars.js data

      // Old, faster way but doesn't get the compare_at_price
      jQuery.each(cart.items, function(index, cartItem) {
                  /* Hack to get product image thumbnail
             *   - If image is not null
             *     - Remove file extension, add _small, and re-add extension
             *     - Create server relative link
             *   - A hard-coded url of no-image
            */
            // if (cartItem.image != null){
            //     var prodImg = cartItem.image.replace(/(\.[^.]*)$/, "_small$1").replace('http:', '');
            // } else {
            //     var prodImg = "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
            // }

            // Create item's data object and add to 'items' array
            item = {
                key: cartItem.key,
                line: index + 1, // Shopify uses a 1+ index in the API
                url: cartItem.url,
                img: cartItem.image,
                name: cartItem.product_title,
                variation: cartItem.variant_title,
                properties: cartItem.properties,
                itemAdd: cartItem.quantity + 1,
                itemMinus: cartItem.quantity - 1,
                itemQty: cartItem.quantity,
                price: Shopify.formatMoney(cartItem.price, $(document.documentElement).data("moneyformat")),
                vendor: cartItem.vendor,
                showVendor: jQuery(settings.showVendor),
                linePrice: Shopify.formatMoney(cartItem.line_price, $(document.documentElement).data("moneyformat")),
                originalLinePrice: Shopify.formatMoney(cartItem.original_line_price, $(document.documentElement).data("moneyformat")),
                discounts: cartItem.discounts,
                discountsApplied: cartItem.line_price === cartItem.original_line_price ? false : true
            };

            items.push(item);
        });

      // New but way slower way but gets the compare_at_price
//         jQuery.each(cart.items, function(index, cartItem) {
//           jQuery.getJSON('/products/'+cartItem.handle+'', function (cart, textStatus) {
//                   /* Hack to get product image thumbnail
//              *   - If image is not null
//              *     - Remove file extension, add _small, and re-add extension
//              *     - Create server relative link
//              *   - A hard-coded url of no-image
//             */
//             if (cartItem.image != null){
//                 var prodImg = cartItem.image.replace(/(\.[^.]*)$/, "_small$1").replace('http:', '');
//             } else {
//                 var prodImg = "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
//             }

//             // Create item's data object and add to 'items' array
//             item = {
//                 key: cartItem.key,
//                 line: index + 1, // Shopify uses a 1+ index in the API
//                 url: cartItem.url,
//                 img: prodImg,
//                 name: cartItem.product_title,
//                 variation: cartItem.variant_title,
//                 properties: cartItem.properties,
//                 itemAdd: cartItem.quantity + 1,
//                 itemMinus: cartItem.quantity - 1,
//                 itemQty: cartItem.quantity,
//                 price: Shopify.formatMoney(cartItem.price, settings.moneyFormat),
//                 vendor: cartItem.vendor,
//                 linePrice: Shopify.formatMoney(cartItem.line_price, settings.moneyFormat),
//                 originalLinePrice: Shopify.formatMoney(cartItem.original_line_price, settings.moneyFormat),
//                 discounts: cartItem.discounts,
//                 discountsApplied: cartItem.line_price === cartItem.original_line_price ? false : true
//             };

//             if (cart.product.variants[0].compare_at_price != null) {
//             	var oldPriceOfItem =  cart.product.variants[0].compare_at_price * cartItem.quantity * 100;
//                 item["oldPrice"] = Shopify.formatMoney(oldPriceOfItem, settings.moneyFormat);
//             }
//             items.push(item);
//           	console.log(items);
//           });
//         });


        // Gather all cart data and add to DOM
        data = {
            items: items,
            note: cart.note,
            totalPrice: Shopify.formatMoney(cart.total_price, $(document.documentElement).data("moneyformat")),
            totalCartDiscount: cart.total_discount === 0 ? 0 : "translation missing: en.cart.general.savings_html".replace('[savings]', Shopify.formatMoney(cart.total_discount, $(document.documentElement).data("moneyformat"))),
            totalCartDiscountApplied: cart.total_discount === 0 ? false : true
    	}

        // No set time out needed when using the old way (without the compare_at_price)
          $cartContainer.append(template(data));

        // Set time out needed when using the new way (with the compare_at_price)
//         setTimeout(function(){
//           $cartContainer.append(template(data));
//         }, 500);



        cartCallback(cart);
    };

    cartCallback = function(cart) {
        $body.removeClass('drawer--is-loading');
        $body.trigger('afterCartLoad.ajaxCart', cart);

        if (window.Shopify && Shopify.StorefrontExpressButtons) {
            Shopify.StorefrontExpressButtons.initialize();
        }
    };

    adjustCart = function () {
        // Delegate all events because elements reload with the cart

        // Add or remove from the quantity
        $body.on('click', '.ajaxcart__qty-adjust', function() {
            if (isUpdating) {
                return;
            }

            var $el = jQuery(this),
                line = $el.data('line'),
                $qtySelector = $el.siblings('.ajaxcart__qty-num'),
                qty = parseInt($qtySelector.val().replace(/\D/g, ''));

            var qty = validateQty(qty);

            // Add or subtract from the current quantity
            if ($el.hasClass('ajaxcart__qty--plus')) {
                qty += 1;
            } else {
                qty -= 1;
                if (qty <= 0) qty = 0;
            }

            // If it has a data-line, update the cart.
            // Otherwise, just update the input's number
            if (line) {
                updateQuantity(line, qty);
            } else {
                $qtySelector.val(qty);
            }
        });

        // Update quantity based on input on change
        $body.on('change', '.ajaxcart__qty-num', function() {
            if (isUpdating) {
                return;
            }

            var $el = jQuery(this),
                line = $el.data('line'),
                qty = parseInt($el.val().replace(/\D/g, ''));

            var qty = validateQty(qty);

            // If it has a data-line, update the cart
            if (line) {
                updateQuantity(line, qty);
            }
        });

        // Prevent cart from being submitted while quantities are changing
        $body.on('submit', 'form.ajaxcart', function(evt) {
            if (isUpdating) {
                evt.preventDefault();
            }
        });

        // Highlight the text when focused
        $body.on('focus', '.ajaxcart__qty-adjust', function() {
            var $el = jQuery(this);
            setTimeout(function() {
                $el.select();
            }, 50);
        });

        function updateQuantity(line, qty) {
            isUpdating = true;

            // Add activity classes when changing cart quantities
            var $row = jQuery('.ajaxcart__row[data-line="' + line + '"]').addClass('is-loading');

            if (qty === 0) {
                $row.parent().addClass('is-removed');
            }

            // Slight delay to make sure removed animation is done
            setTimeout(function() {
                ShopifyAPI.changeItem(line, qty, adjustCartCallback);
            }, 250);
        }

        // Save note anytime it's changed
        $body.on('change', 'textarea[name="note"]', function() {
            var newNote = jQuery(this).val();

            // Update the cart note in case they don't click update/checkout
            ShopifyAPI.updateCartNote(newNote, function(cart) {});
        });
    };

    adjustCartCallback = function (cart) {
        // Update quantity and price
        updateCountPrice(cart);

        // Reprint cart on short timeout so you don't see the content being removed
        setTimeout(function() {
            isUpdating = false;
            ShopifyAPI.getCart(buildCart);
        }, 150)
    };

    createQtySelectors = function() {
        // If there is a normal quantity number field in the ajax cart, replace it with our version
        if (jQuery('input[type="number"]', $cartContainer).length) {
            jQuery('input[type="number"]', $cartContainer).each(function() {
                var $el = jQuery(this),
                    currentQty = $el.val();

                var itemAdd = currentQty + 1,
                    itemMinus = currentQty - 1,
                    itemQty = currentQty;

                var source   = jQuery("#AjaxQty").html(),
                    template = Handlebars.compile(source),
                    data = {
                        key: $el.data('id'),
                        itemQty: itemQty,
                        itemAdd: itemAdd,
                        itemMinus: itemMinus
                    };

                // Append new quantity selector then remove original
                $el.after(template(data)).remove();
            });
        }
    };

    qtySelectors = function() {
        // Change number inputs to JS ones, similar to ajax cart but without API integration.
        // Make sure to add the existing name and id to the new input element
        var numInputs = jQuery('input[type="number"]');

        if (numInputs.length) {
            numInputs.each(function() {
                var $el = jQuery(this),
                    currentQty = $el.val(),
                    inputName = $el.attr('name'),
                    inputId = $el.attr('id');

                var itemAdd = currentQty + 1,
                    itemMinus = currentQty - 1,
                    itemQty = currentQty;

                var source   = jQuery("#JsQty").html(),
                    template = Handlebars.compile(source),
                    data = {
                        key: $el.data('id'),
                        itemQty: itemQty,
                        itemAdd: itemAdd,
                        itemMinus: itemMinus,
                        inputName: inputName,
                        inputId: inputId
                    };

                // Append new quantity selector then remove original
                $el.after(template(data)).remove();
            });

            // Setup listeners to add/subtract from the input
            jQuery('.js-qty__adjust').on('click', function() {
                var $el = jQuery(this),
                    id = $el.data('id'),
                    $qtySelector = $el.siblings('.js-qty__num'),
                    qty = parseInt($qtySelector.val().replace(/\D/g, ''));

                var qty = validateQty(qty);

                // Add or subtract from the current quantity
                if ($el.hasClass('js-qty__adjust--plus')) {
                    qty += 1;
                } else {
                    qty -= 1;
                    if (qty <= 1) qty = 1;
                }

                // Update the input's number
                $qtySelector.val(qty);
            });
        }
    };

    validateQty = function (qty) {
        if((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
            // We have a valid number!
        } else {
            // Not a number. Default to 1.
            qty = 1;
        }
        return qty;
    };

    module = {
        init: init,
        load: loadCart
    };

    return module;

}(ajaxCart || {}, jQuery));
